import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  FiHome,
  FiMap,
  FiUpload,
  FiUsers,
  FiSettings,
  FiLogOut,
  FiUser,
  FiGitBranch
} from 'react-icons/fi';

const Sidebar = ({ isOpen, expanded, onClose }) => {
  const location = useLocation();
  const { user, isAuthenticated, logout } = useAuth();

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    logout();
    onClose();
  };

  const userName = user?.username || user?.name || 'User';
  const displayName = userName.length > 10 ? `${userName.substring(0, 8)}...` : userName;
  const userEmail = user?.email || 'user@example.com';
  const displayEmail = userEmail.length > 18 ? `${userEmail.substring(0, 16)}...` : userEmail;

  return (
    <aside
      // className={`fixed top-0 left-0 h-full bg-gray-800 text-white shadow-lg transition-all duration-300 m-0 p-0 ${
      //   isOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'
      // } ${expanded ? 'w-48' : 'w-0'}`}
      className={`fixed top-0 left-0 h-full bg-gray-800 text-white shadow-lg transition-all duration-300 m-0 p-0 ${
      isOpen ? 'translate-x-0' : '-translate-x-full'
     } ${expanded ? 'w-48' : 'w-12'}`}
    >
      <div className="h-full flex flex-col">
        {/* Logo Section */}
        <div className="p-2 border-b border-gray-700 flex items-center justify-center h-10">
          <Link to="/dashboard" className="flex items-center gap-1" onClick={onClose}>
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 7L12 12L22 7L12 2Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            {expanded && <span className="text-xs font-bold">GIS APP</span>}
          </Link>
        </div>

        {/* Navigation Links */}
        <nav className="flex-1 overflow-y-auto py-2 flex flex-col justify-between">
          <ul className="space-y-0.5">
            {isAuthenticated && (
              <li className="border-b border-gray-700 p-2">
                <div className="flex items-center">
                  <div className="w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center text-white font-bold text-xs">
                    {userName.charAt(0) || 'U'}
                  </div>
                  {expanded && (
                    <div className="ml-2 overflow-hidden">
                      <p className="text-xs font-medium truncate" title={userName}>{displayName}</p>
                      <p className="text-[10px] text-gray-400 truncate" title={userEmail}>{displayEmail}</p>
                    </div>
                  )}
                </div>
              </li>
            )}
            <li>
              <Link
                to="/dashboard"
                onClick={onClose}
                className={`flex items-center px-3 py-2 hover:bg-gray-700 transition-colors ${isActive('/dashboard') ? 'bg-blue-700' : ''} ${expanded ? 'justify-start' : 'justify-center'}`}
              >
                <FiHome className="w-4 h-4" />
                {expanded && <span className="ml-2 text-xs">Dashboard</span>}
              </Link>
            </li>
            <li>
              <Link
                to="/maps"
                onClick={onClose}
                className={`flex items-center px-3 py-2 hover:bg-gray-700 transition-colors ${isActive('/maps') ? 'bg-blue-700' : ''} ${expanded ? 'justify-start' : 'justify-center'}`}
              >
                <FiMap className="w-4 h-4" />
                {expanded && <span className="ml-2 text-xs">Map</span>}
              </Link>
            </li>
            {/* Additional links can go here */}
          </ul>

          {/* Logout Button at bottom of nav */}
          <div className="p-2 border-t border-gray-700">
            <button
              onClick={handleLogout}
              className="w-full flex items-center justify-center px-2 py-1.5 bg-red-600 hover:bg-red-700 text-white rounded-md transition-colors"
            >
              <FiLogOut className="w-4 h-4" />
              {expanded && <span className="ml-2 text-xs">Logout</span>}
            </button>
          </div>
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;


// import React from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import { useAuth } from '../../context/AuthContext';
// import {
//   FiHome,
//   FiMap,
//   FiUpload,
//   FiUsers,
//   FiSettings,
//   FiLogOut,
//   FiUser,
//   FiGitBranch
// } from 'react-icons/fi';

// const Sidebar = ({ isOpen, expanded, onClose }) => {
//   const location = useLocation();
//   const { user, isAuthenticated, logout } = useAuth();

//   const isActive = (path) => {
//     return location.pathname === path;
//   };

//   const handleLogout = () => {
//     logout();
//     onClose(); // Close the sidebar after logout
//   };

//   // Truncate username if too long
//   const userName = user?.name || 'User';
//   const displayName = userName.length > 10 ? `${userName.substring(0, 8)}...` : userName;
//   const userEmail = user?.email || 'user@example.com';
//   const displayEmail = userEmail.length > 18 ? `${userEmail.substring(0, 16)}...` : userEmail;

//   return (
//     <aside 
//       className={`fixed top-0 left-0 h-full bg-gray-800 text-white shadow-lg transition-all duration-300 m-0 p-0 ${
//         isOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'
//       } ${expanded ? 'w-48' : 'w-0'} `}
//     >
//       <div className="h-full flex flex-col">
//         {/* Logo Section - Smaller */}
//         <div className="p-2 border-b border-gray-700 flex items-center justify-center h-10">
//           <Link to="/dashboard" className="flex items-center gap-1" onClick={onClose}>
//             <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//               <path d="M12 2L2 7L12 12L22 7L12 2Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//               <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//               <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//             </svg>
//             {expanded && <span className="text-xs font-bold">GIS APP</span>}
//           </Link>
//         </div>



//         {/* Navigation Links - Smaller */}
//         <nav className="flex-1 overflow-y-auto py-2">
//           <ul className="space-y-0.5">

//         {/* User Info Section - Smaller */}
//         {isAuthenticated && (
//           <div className={`border-b border-gray-700 p-2 ${expanded ? 'flex items-center' : 'text-center'}`}>
//             <div className="w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center text-white font-bold text-xs">
//               {user?.name?.charAt(0) || 'U'}
//             </div>
//             {expanded && (
//               <div className="ml-2 overflow-hidden">
//                 <p className="text-xs font-medium truncate" title={userName}>{displayName}</p>
//                 <p className="text-[10px] text-gray-400 truncate" title={userEmail}>{displayEmail}</p>
//               </div>
//             )}
//           </div>
//         )}
//           <li>
//             <Link
//               to="/dashboard"
//               className={`flex items-center px-3 py-2 hover:bg-gray-700 transition-colors ${
//                 isActive('/dashboard') ? 'bg-blue-700' : ''
//               } ${expanded ? 'justify-start' : 'justify-center'}`}
//               onClick={onClose}
//             >
//               <FiHome className="w-4 h-4" />
//               {expanded && <span className="ml-2 text-xs">Dashboard</span>}
//             </Link>
//           </li>
//             <li>
//               <Link
//                 to="/map"
//                 className={`flex items-center px-3 py-2 hover:bg-gray-700 transition-colors ${
//                   isActive('/map') ? 'bg-blue-700' : ''
//                 } ${expanded ? 'justify-start' : 'justify-center'}`}
//                 onClick={onClose}
//               >
//                 <FiMap className="w-4 h-4" />
//                 {expanded && <span className="ml-2 text-xs">Map</span>}
//               </Link>
//             </li>
//             {/* <li>
//               <Link
//                 to="/update-branches"
//                 className={`flex items-center px-3 py-2 hover:bg-gray-700 transition-colors ${
//                   isActive('/shapefile') ? 'bg-blue-700' : ''
//                 } ${expanded ? 'justify-start' : 'justify-center'}`}
//                 onClick={onClose}
//               >
//                 <FiGitBranch className="w-4 h-4" />
//                 {expanded && <span className="ml-2 text-xs">Update Branches</span>}
//               </Link>
//             </li>
//             <li>
//               <Link
//                 to="/upload-shapefile"
//                 className={`flex items-center px-3 py-2 hover:bg-gray-700 transition-colors ${
//                   isActive('/') ? 'bg-blue-700' : ''
//                 } ${expanded ? 'justify-start' : 'justify-center'}`}
//                 onClick={onClose}
//               >
//                 <FiUpload className="w-4 h-4" />
//                 {expanded && <span className="ml-2 text-xs">Upload</span>}
//               </Link>
//             </li>
//             <li>
//               <Link
//                 to="/users"
//                 className={`flex items-center px-3 py-2 hover:bg-gray-700 transition-colors ${
//                   isActive('/shapefile') ? 'bg-blue-700' : ''
//                 } ${expanded ? 'justify-start' : 'justify-center'}`}
//                 onClick={onClose}
//               >
//                 <FiUser className="w-4 h-4" />
//                 {expanded && <span className="ml-2 text-xs">Users</span>}
//               </Link>
//             </li>
//             <li>
//               <Link
//                 to="/settings"
//                 className={`flex items-center px-3 py-2 hover:bg-gray-700 transition-colors ${
//                   isActive('/shapefile') ? 'bg-blue-700' : ''
//                 } ${expanded ? 'justify-start' : 'justify-center'}`}
//                 onClick={onClose}
//               >
//                 <FiSettings className="w-4 h-4" />
//                 {expanded && <span className="ml-2 text-xs">Settings</span>}
//               </Link>
//             </li> */}
//           </ul>

          
//         {/* Logout Button - Smaller */}
//         <div className="bottom-0 p-2 border-t border-gray-700">
//           <button
//             onClick={handleLogout}
//             className="w-full flex items-center justify-center px-2 py-1.5 bg-red-600 hover:bg-red-700 text-white rounded-md transition-colors"
//           >
//             <FiLogOut className="w-4 h-4" />
//             {expanded && <span className="ml-2 text-xs">Logout</span>}
//           </button>
//         </div>
//         </nav>

//       </div>
//     </aside>
//   );
// };

// export default Sidebar;
